var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('slots-list',{attrs:{"item-key":"id","headers":_vm.headers,"slots":_vm.slots,"loading":_vm.loading,"loading-text":"Đang Tải"},on:{"change":_vm.onDateChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }